import { useMemo } from 'react';

function useIndexForLabels(data) {
  return useMemo(() => {
    return data.reduce((longestIndex, currentSeries, index, array) => {
      const previousSeries = array[index - 1];

      if (previousSeries && previousSeries.data.length < currentSeries.data.length) {
        return index;
      }

      return longestIndex;
    }, 0);
  }, [data]);
}

export { useIndexForLabels };
